import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { formatDate } from './helpers'
import InlineFeedbackDisplay from './InlineFeedbackDisplay'

const ROLE_USER = 1
const ROLE_ASSISTANT = 3

const ThreadMessage = ({ message }) => {
  const theme = useTheme()
  const isUser = message.role === ROLE_USER
  const isAssistant = message.role === ROLE_ASSISTANT

  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 1,
        bgcolor: isUser ? theme.palette.grey[100] : theme.palette.background.paper,
        border: `1px solid ${isUser ? theme.palette.grey[200] : theme.palette.grey[300]}`,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
        <Typography
          variant='caption'
          fontWeight='bold'
          color={isUser ? 'textPrimary' : 'secondary'}
        >
          {isUser ? 'User' : 'Stethi'}
        </Typography>
        <Typography variant='caption' color='textSecondary'>
          {formatDate(message.createdAt)}
        </Typography>
      </Box>

      <Typography variant='body2' sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {message.content}
      </Typography>

      {isAssistant && message.feedback?.map(fb => (
        <InlineFeedbackDisplay key={fb.id} feedback={fb} />
      ))}
    </Box>
  )
}

export default ThreadMessage
